import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../../server/validationMethods.js'
import Draft from './draft.js';
class IncomeOption extends Component {
    constructor(props){
        super(props)
        this.state={
            hasError:false
        }
        this.childComponentRef = React.createRef();
    }
render(){
    const { t, i18n } = this.props;
     return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <p className="color-1">{t("You have indicated that {''} receive assistance under the McKinney-Vento Homeless Assistance Act, participate in the Migrant Education Program (MEP), participate in a program under the Runaway and Homeless Youth Act, or are enrolled in the Head Start program")}.</p>
                        <p><Trans>We just need to confirm that with program staff</Trans>. <Trans>If we are unable to do that, you will need to submit an application with income information to determine your benefit level</Trans>.</p>
                    </div>
                </div>
            </div>            
            
            <div className="row">
                <div className="col-xs-12">
                    <ul>
                        <li>
                            <div className="styled-input-single" style={{padding: '0px 0px 0px 33px'}}>
                                    <input id={'runawayYes'} name={'isIncomeAfter'} checked={ this.props.lunchObj.isIncomeAfter===true}
                                    type='radio' onChange={(e)=>{
                                        this.props.onSelectionChange(e.target.name,e.target.checked?true:false);
                                        this.setState({hasError:false}) 
                                        this.childComponentRef.current.formatDraftReqObj();                                        
                                    }} /> 
                                    <label htmlFor={'runawayYes'}>
                                    <Trans>{'Provide income information now'}</Trans></label>
                            </div>
                        </li>
                        <li>
                            <div className="styled-input-single" style={{padding: '0px 0px 0px 33px'}}>
                                <input id={'runawayNo'} name={'isIncomeAfter'} checked={this.props.lunchObj.isIncomeAfter===false}
                                    type='radio' onChange={(e)=>{
                                       this.props.onSelectionChange(e.target.name,e.target.checked?false:true); 
                                       this.setState({hasError:false}) 
                                       this.childComponentRef.current.formatDraftReqObj();                                          
                                    }} /> 
                                <label htmlFor={'runawayNo'}>
                                <Trans>{'Submit my application without income information'}</Trans></label>
                            </div>
                        </li>
                    </ul>                
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    {
                        this.state.hasError?<span className="text-danger"> <Trans>Please enter all required information above</Trans>.</span>:null
                    }
                </div>
            </div>
            
            <div className="row">
                <div className="col-xs-12">
                    <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{                        
                        this.props.jumpToStep(6)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{  
                        if(this.props.lunchObj.isIncomeAfter===true)                      
                            this.props.jumpToStep(8);
                        else if(this.props.lunchObj.isIncomeAfter===false){
                            this.props.jumpToStep(12);
                        }else{
                            this.setState({hasError:true})

                        }
                    }}><Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} ref={this.childComponentRef} isDistrict={this.props.isDistrict} />
                </div>
            </div>
        </div>
    )
}
}
export default translate("translations")(IncomeOption);


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/incomeOption.jsx